import React from 'react';
import { isEmpty, toLower } from 'lodash';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import { FilterResultMessage, SectionWrapper } from './styles/VenuesFilter.styled';
import ImageCardsCarousel from './ImageCardsCarousel';
import VenuesFilterBar from './VenuesFilterBar';
import venueFilterValues from '../assets/data/venues-filter-values.json';

export default function VenuesFilter({ data, dir, id }) {
  const { translations } = React.useContext(DWTCContext);
  const isArabic = dir === 'rtl';
  const filteredVenuesSettings = {
    title: dir === 'rtl' ? 'قاعات مرنة' : 'Flexible Venues',
    imageCards: [],
  };

  const [venueType, setVenueType] = React.useState(null);
  const [filteredVenues, setFilteredVenues] = React.useState(filteredVenuesSettings);

  const allValues = [
    ...data.venuesCarousel[0].content.imageCards,
    ...data.venuesCarousel[1].content.imageCards,
  ];

  const translate = (list, key) => {
    if (isEmpty(list)) return key;
    const filteredItem = list.find(({ key: listKey }) => toLower(listKey) === toLower(key));
    if (isEmpty(filteredItem)) return key;
    if (isArabic) return filteredItem.value;
    return filteredItem.key;
  };

  React.useEffect(() => {
    if (venueType === 'اختر نوع الفعالية') setVenueType(null);
    if (venueType === 'Choose the type of event') setVenueType(null);
  }, [venueType]);

  React.useEffect(() => {
    let results = [];
    if (venueType) {
      if (isArabic && venueType !== 'اختر نوع الفعالية') {
        venueFilterValues[translate(translations, venueType)].forEach((value) => {
          const filtered = allValues.filter(
            ({ content }) => content.title === translate(translations, value),
          );
          results = [...results, ...filtered];
        });
      } else if (!isArabic && venueType !== 'Choose the type of event') {
        venueFilterValues[venueType].forEach((value) => {
          const filtered = allValues.filter(({ content }) => content.title === value);
          results = [...results, ...filtered];
        });
      }
      setFilteredVenues({ ...filteredVenues, imageCards: results });
    } else setFilteredVenues(filteredVenuesSettings);
  }, [venueType]);

  if (venueType) {
    return (
      <SectionWrapper id={id} dir={dir}>
        <VenuesFilterBar data={data} dir={dir} setVenueType={setVenueType} />
        <>
          <FilterResultMessage isArabic={isArabic}>
            {`${getTranslationByKey(translations, 'Showing results for')} "${venueType}"`}
          </FilterResultMessage>
          {isEmpty(filteredVenues.imageCards) && (
            <FilterResultMessage isArabic={isArabic}>
              {`${getTranslationByKey(translations, 'Your search did not return any results')}.`}
            </FilterResultMessage>
          )}
          <ImageCardsCarousel data={filteredVenues} id="$filteredImageCardsCarousel_1" dir={dir} />
        </>
      </SectionWrapper>
    );
  }

  return (
    <SectionWrapper id={id} dir={dir}>
      <VenuesFilterBar data={data} dir={dir} setVenueType={setVenueType} />
      {data.venuesCarousel.map(({ content }, index) => (
        <ImageCardsCarousel
          data={content}
          id={`${content.contentTypeAlias}_${index + 1}`}
          dir={dir}
        />
      ))}
    </SectionWrapper>
  );
}
